export const bindFetch = () => window.window.fetch.bind(window)
